import { useFeatureGate } from "@statsig/react-bindings";
import { useCallback } from "react";
import { telehealthManualAdmissionFlowGate } from "../statsig/gates";
import { Statsig } from "../statsig/StatsigProvider";
import { AdmissionFlow } from "../types";
import { VideoPlatform } from "../video-sdk";
import { useVideoPlatform, useVideoPlatformCallback } from "./useVideoPlatform";

function getAdmissionFlow(
  videoPlatform: VideoPlatform | null,
  isManualAdmissionFlowEnabled: boolean,
): AdmissionFlow {
  return videoPlatform === VideoPlatform.Zoom && isManualAdmissionFlowEnabled
    ? "manual"
    : "auto";
}

/**
 * The client user checks this gate and relays their admission flow to the
 * provider side as part of their presence updates.
 */
export function useAdmissionFlow(): AdmissionFlow {
  const { value: isManualAdmissionFlowEnabled } = useFeatureGate(
    telehealthManualAdmissionFlowGate,
  );
  const videoPlatform = useVideoPlatform();

  return getAdmissionFlow(videoPlatform, isManualAdmissionFlowEnabled);
}

export function useAdmissionFlowCallback(): () => AdmissionFlow {
  const getVideoPlatform = useVideoPlatformCallback();

  return useCallback(() => {
    return getAdmissionFlow(
      getVideoPlatform(),
      Statsig.checkGate(telehealthManualAdmissionFlowGate),
    );
  }, [getVideoPlatform]);
}
